import React from "react";

import { useTranslate } from "localization";
import { Tooltip } from "minimum-ui/core";
import { Filter } from "ui/forms";

import { skipToken, useTaskReportingYearsQuery } from "API";

import useFilterParam from "./useFilterParam";

const TaskReportingYear: React.FC<{ organisationId: string }> = ({
  organisationId,
}) => {
  const { translate } = useTranslate();
  const title = translate("reportingYear");

  const {
    data = [],
    isSuccess,
    isError,
  } = useTaskReportingYearsQuery(
    organisationId ? { organisationId } : skipToken,
    {
      selectFromResult: (result) => ({
        ...result,
        data: result.data?.map((item) => ({
          value: item.id,
          label: item.label ?? "Unknown",
        })),
      }),
    }
  );

  const [selected, setSelected] = useFilterParam("task_reporting_years", data, {
    defaultToFirst: false,
    ready: isSuccess || isError,
  });

  const selectedLabel = data.find((o) => o.value === selected)?.label ?? title;

  return !isSuccess ? (
    <Tooltip title={translate("reportingYearTooltip")} placement="bottom">
      <Filter
        items={{ options: data }}
        title={title}
        label={selectedLabel}
        selected={!!selected}
        onChange={setSelected}
        disabled={!isSuccess}
        value={selected ?? ""}
        showReset={true}
        showApply={true}
        translate={translate}
      />
    </Tooltip>
  ) : (
    <Filter
      items={{ options: data }}
      title={title}
      label={selectedLabel}
      selected={!!selected}
      onChange={setSelected}
      disabled={!isSuccess}
      value={selected ?? ""}
      showReset={true}
      showApply={true}
      translate={translate}
    />
  );
};

export default TaskReportingYear;
